import { defineStore } from "pinia";
import Category from "@/types/Category";
import { Ref, ref } from "vue";
import getCategories from "@/api/requests/getCategories";

export const useCategoriesStore = defineStore("categories", () => {
  const base: Category = {
    id: "",
    title: "Todas",
    icon: "mdi-circle",
    tag: "",
    order: 0,
  };

  const list = ref<Category[]>([
    base,
  ]);

  const selected: Ref<Category> = ref(base);

  async function fetchCategories() {
    const response = await getCategories();

    list.value = [
      base,
      ...response,
    ];
  }

  fetchCategories();

  return { list, selected, fetchCategories };
});
